import {openCartAside} from "//auriccosmetics.com/cdn/shop/t/57/assets/cart-aside.js?v=104507585006979217871777416288";
import {forceCartReload} from "//auriccosmetics.com/cdn/shop/t/57/assets/cart.js?v=64308783058593828011777399015";
// import './cart-notification.js'

class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.formId = this.form.attributes['id'].value;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    // this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    // this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      // sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then(async (parsedState) => {
        await forceCartReload();
        openCartAside();
        // this.cartNotification.renderContents(parsedState);
        const quantityInput = document.querySelector(`input.quantity__input[form=${this.formId}]`);
        quantityInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
